import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Download, Loader2 } from "lucide-react";

const MAX_PAGES = 30;

// Mostra mesmo o ficheiro: imagens diretas; PDF/Word/HEIC em páginas PNG feitas no servidor (funciona em qualquer telemóvel).
export function DocViewer({ fileId, title, onClose }) {
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!fileId) { return; }
    setInfo(null); setErr("");
    api.get(`/files/${fileId}/info`).then(({ data }) => setInfo(data)).catch(() => setErr("Não foi possível abrir este ficheiro."));
  }, [fileId]);
  const n = info ? Math.min(info.pages, MAX_PAGES) : 0;
  return (
    <Dialog open={!!fileId} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-4xl w-[96vw] max-h-[92vh] overflow-y-auto bg-white p-4 sm:p-6" data-testid="doc-viewer">
        <DialogHeader>
          <DialogTitle className="font-heading navy-text pr-8 text-left" data-testid="doc-viewer-title">{title}</DialogTitle>
          <DialogDescription className="text-left text-sm text-slate-500" data-testid="doc-viewer-meta">
            {info ? `${info.filename || "Ficheiro"}${info.kind === "pages" ? ` · ${info.pages} ${info.pages === 1 ? "página" : "páginas"}` : ""}` : " "}
          </DialogDescription>
        </DialogHeader>
        {err && <p className="text-sm text-red-700 bg-red-50 rounded-lg px-3 py-2" data-testid="doc-viewer-error">{err}</p>}
        {!info && !err && <div className="py-16 grid place-items-center text-slate-400"><Loader2 className="animate-spin" /></div>}
        {info && (
          <div className="space-y-3 bg-slate-100 rounded-xl p-2 sm:p-3" data-testid="doc-viewer-pages">
            {info.kind === "image"
              ? <img src={`${API}/files/${fileId}`} alt={title} className="w-full h-auto rounded-lg bg-white" data-testid="doc-viewer-image" />
              : Array.from({ length: n }, (_, i) => (
                <img key={i} src={`${API}/files/${fileId}/preview?page=${i}`} alt={`${title} · página ${i + 1}`} loading="lazy"
                  className="w-full h-auto rounded-lg bg-white shadow-sm min-h-[200px]" data-testid={`doc-viewer-page-${i}`} />
              ))}
            {info.pages > MAX_PAGES && <p className="text-sm text-slate-500 text-center">Mostradas as primeiras {MAX_PAGES} páginas. Descarregue para ver todas.</p>}
          </div>
        )}
        {info && (
          <div className="flex justify-end">
            <a href={`${API}/files/${fileId}?original=true`} download={info.filename || true}
              className="h-10 inline-flex items-center gap-2 px-4 rounded-[14px] border border-slate-300 bg-white text-sm font-semibold text-slate-800 hover:bg-slate-50 transition-colors" data-testid="doc-viewer-download">
              <Download size={15} /> Descarregar
            </a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
